import * as yup from 'yup';
import moment from 'moment'

yup.setLocale({
    mixed: {
        required: 'This field is required',
    },
    string: {
        email: 'Invalid email',
        url: 'Invalid URL',
    },
});

//https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s02.html#:~:text=Allow%20a%20leading%20%E2%80%9C1%E2%80%9D&text=In%20addition%20to%20the%20phone,%2D123%2D456%2D7890%20.
const phoneRegExp = /^(?:\+?1[-.●]?)?\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/;

const dateFormat = 'MM/DD/YYYY';

let schema = yup.object().shape({
    // General Info - Company Information
    applicantType: yup.string().required(),
    companyName: yup.string().trim().required(),
    yearEst: yup.string().nullable().notRequired(),
    stateInc: yup.string(),
    yearsWithName: yup.string().nullable().notRequired(),
    priorCompanyNames: yup.string().trim(),
    hqMailingAddress: yup.string().trim().required(),
    hqStreetAddress: yup.string().trim(),
    city: yup.string().trim().required(),
    state: yup.string().required(),
    zip: yup.string().trim().required(),
    country: yup.string().required(),
    // General Info - POC Name/Title
    pocFirstName: yup.string().trim().required(),
    pocLastName: yup.string().trim().required(),
    pocTitle: yup.string().trim().required(),
    pocEmail: yup.string().trim().email().required(),
    pocPhoneNumber: yup.string().trim().required().matches(phoneRegExp, 'Phone number is not valid'),
    pocAltEmail: yup.string().trim().email(),
    // General Info - Alutiiq Contact
    revenue: yup.string().required(),
    alutiiqContactFirstName: yup.string().trim().required(),
    alutiiqContactLastName: yup.string().trim().required(),
    division: yup.string(),
    alutiiqSubsidiary: yup.string().required(),
    // General Info - Additional Information
    DCAAPOCFirstName: yup.string().trim(),
    DCAAPOCLastName: yup.string().trim(),
    DCAAPOCPhone: yup.string().trim().matches(phoneRegExp, 'Phone number is not valid'),
    DCAAPOCEmail: yup.string().trim().email(),

    // Business Profile - Business Profile
    businessClass: yup.string(),
    owners: yup.array().of(yup.object({
        name: yup.string().trim(),
        title: yup.string().trim(),
        ownership: yup.string().nullable()
    })),
    isOwnerOtherCompanies: yup.string().required(),
    isOwnerFamily: yup.string().required(),
    // Business Profile - Socio Economic Status
    socioEconomicStatus: yup.array().required(),
    rblCerts: yup.string(),
    rblRegisteredDunBradstreet: yup.string(),
    ueiNumber: yup.string().when('SAMRegistration', {
        is: 'True',
        then: yup.string().required(),
    }),
    dbNumber: yup.string(),
    dbYear: yup.string(),
    taxID: yup.string().trim(),
    companyWebsite: yup.string().trim().url(),
    SAMRegistration: yup.string().required(),
    CAGECode: yup.string().trim().required(),
    NAICSCode: yup.string().trim().required(),
    otherNAICSCodes: yup.string().trim(),
    businessProfileAreYouManufacturer: yup.string(),
    businessProfileMajorProductsManufactured: yup.string().trim(),
    businessProfileDoEngageConsulting: yup.string(),
    businessProfileMajorAreasExpertise: yup.string().trim(),
    businessProfileDoSubcontractLabor: yup.string(),
    businessProfilePrimaryService: yup.string().trim(),
    businessProfileStatesConductBusiness: yup.string().trim(),
    businessProfileGrossIncome: yup.string().required(),
    businessProfileCompensationInformationAccess: yup.string().when('businessProfileGrossIncome', {
        is: 'True',
        then: yup.string().required(),
    }),
    ffataForm: yup.string().nullable(),
    businessProfileEightyPercentRevenue: yup.string().when('businessProfileCompensationInformationAccess', {
        is: 'False',
        then: yup.string().required(),
    }),
    businessProfileTwentyFiveMillionRevenue: yup.string().when('businessProfileCompensationInformationAccess', {
        is: 'False',
        then: yup.string().required(),
    }),

    // Capabilities - Capabilities
    businessActivities: yup.array().required(),
    txtkStates: yup.string().trim(),

    // Past Performance - Past Performance
    capableCertifiedPayrolls: yup.string().required(),
    receivedShowOfCauseEtc: yup.string().required(),
    receivedShowOfCauseEtcExplanation: yup.string().trim().when('receivedShowOfCauseEtc', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    receivedNoticeOfDefault: yup.string().required(),
    receivedNoticeOfDefaultExplanation: yup.string().trim().when('receivedNoticeOfDefault', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    everBankrupt: yup.string().required(),
    everBankruptExplanation: yup.string().trim().when('everBankrupt', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    everDisbarred: yup.string().required(),
    everDisbarredExplanation: yup.string().trim().when('everDisbarred', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    everFined: yup.string().required(),
    everFinedExplanation: yup.string().trim().when('everFined', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    issuesWithDCAA: yup.string().required(),
    issuesWithDCAAExplanation: yup.string().trim().when('issuesWithDCAA', {
        is: 'True',
        then: yup.string().trim().required(),
    }),

    // Bonding - Bonding Program Information
    suretyBondingProgram: yup.string().when('division', {
        is: 'Construction',
        then: yup.string().required(),
    }),
    bidBonds: yup.string().when('division', {
        is: 'Construction',
        then: yup.string().required(),
    }),

    // Insurance and Saftey - Insurance Information
    insuranceRequiredByScopeofWork: yup.string().required(),

    // Insurance and Saftey - Safety
    safetyPro: yup.string().required(),
    pName: yup.string().trim().when('safetyPro', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    pTitle: yup.string().trim().when('safetyPro', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    pPhone: yup.string().trim().matches(phoneRegExp, 'Phone number is not valid').when('safetyPro', {
        is: 'True',
        then: yup.string().trim().matches(phoneRegExp, 'Phone number is not valid').required(),
    }),
    pEmail: yup.string().trim().email().when('safetyPro', {
        is: 'True',
        then: yup.string().trim().email().required(),
    }),
    OSHACitations: yup.string().required(),
    oshaCitationType: yup.string().trim().when('OSHACitations', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    oshaFineAmounts: yup.string().trim().when('OSHACitations', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    oshaAbatement: yup.string().trim().when('OSHACitations', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    oshaContact: yup.string().trim().when('OSHACitations', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    // Security and Certifications - Status of Subcontractor Business Systems
    accountingSystem: yup.string(),
    accountingSystemApprovalDate: yup.string().trim(),
    purchasingSystem: yup.string(),
    estimatingSystem: yup.string(),
    propertySystem: yup.string(),
    compliantIT: yup.string().required(),
    compliantITFileName: yup.string().nullable().when('compliantIT', {
        is: 'True',
        then: yup.string(),
    }),
    canReviewSSP: yup.string().required(),
    // Security and Certifications - Security Clearance
    facilitySecurityClearance: yup.string().required(),
    securityClearances: yup.array().of(
        yup.object().shape({
            federalAgency: yup.string().trim().required(),
            clearanceLevel: yup.string().trim().required(),
            dateOfApproval: yup.string().nullable().trim().required()
        })
    ),
    cageCodes: yup.array().of(
        yup.object().shape({
            SSP: yup.string().trim().required(),
            supportedBySSP: yup.string().trim().required(),
            dateOfAssessment: yup.string().nullable().trim().required(),
            totalScore: yup.string().trim().required(),
            estimatedDateOfAchievement: yup.string().nullable().trim().required()
        })
    ),
    poamSSP: yup.string().trim().when('NISTSP800171Assessment', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    companyAssessmentScore: yup.string().trim().when('NISTSP800171Assessment', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    securityClearanceNotes: yup.string().trim(),
    NISTSP800171Compliant: yup.string().trim(),
    SecuritySystemPlan: yup.string().trim(),
    securitySystemPlanFileName: yup.string().nullable().when('canReviewSSP', {
         is: 'True',
         then: yup.string(),
    }),
    NISTSP800171Assessment: yup.string().required(),
    NISTSP800171AssessmentFileName: yup.string().nullable().when('NISTSP800171Assessment', {
        is: 'True',
        then: yup.string().required(),
    }),
    NISTSP800171AssessmentScore: yup.string().trim(),
    NISTSP800171AssessmentDate: yup.string().trim(),
    NISTSP800171AssessmentDateofScore110: yup.string().trim(),
    CybersecurityMaturityModelCertified: yup.string().required(),
    CybersecurityMaturityModelCertifiedDate: yup.string().trim().when('CybersecurityMaturityModelCertified', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    CybersecurityMaturityModelCertifiedCMMCLevel: yup.string().trim().when('CybersecurityMaturityModelCertified', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    CybersecurityMaturityModelCertifiedCMMCPassingScore: yup.string().trim().when('CybersecurityMaturityModelCertified', {
        is: 'False',
        then: yup.string().trim().required(),
    }),

    // Compliance - Combatting Trafficking in Persons
    awareOfFARClause: yup.string().required(),
    haveEndingTraffickingPolicy: yup.string().required(),
    haveCodeOfBusinessEthicsAndConduct: yup.string().required(),
    haveCodeTrainingMaterials: yup.string().required(),
    freeToTerminate: yup.string().required(),
    freeToTerminateExplanation: yup.string().trim().when('freeToTerminate', {
        is: 'False',
        then: yup.string().trim().required(),
    }),
    depositsRequired: yup.string().required(),
    depositsRequiredExplanation: yup.string().trim().when('depositsRequired', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    assessPossibleTrafficking: yup.string().required(),
    assessPossibleTraffickingExplanation: yup.string().trim().when('assessPossibleTrafficking', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    freqAssessPossibleTrafficking: yup.string().trim().when('assessPossibleTrafficking', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    possibleTrafficking: yup.string().when('assessPossibleTrafficking', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    possibleTraffickingExplanation: yup.string().trim().when('possibleTrafficking', {
        is: 'True',
        then: yup.string().trim().when('assessPossibleTrafficking', {
            is: 'True',
            then: yup.string().trim().required(),
        }),
    }),
    otherEndingTraffickingPolicy: yup.string().trim().when('haveEndingTraffickingPolicy', {
        is: 'False',
        then: yup.string().trim().required(),
    }).when('assessPossibleTrafficking', {
        is: 'False',
        then: yup.string().trim().required(),
    }),
    boycottTraffickers: yup.string().required(),

    // Signature - Required Materials and File Uploads
    w9: yup.string().trim().required(),
    coi: yup.string().trim(),
    balanceSheet: yup.string().trim(),
    workersCompensationEMR: yup.string().trim(),
    endingTraffickingPolicy: yup.string().trim(),
    codeOfBusinessEthicsAndConduct: yup.string().trim().when('haveCodeOfBusinessEthicsAndConduct', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    codeTrainingMaterials: yup.string().trim().when('haveCodeTrainingMaterials', {
        is: 'True',
        then: yup.string().trim().required(),
    }),
    // Signature - Ending Trafficking in Persons Compliance Statement / Authorization to Release Information
    signatureFirstName: yup.string().trim().required(),
    signatureLastName: yup.string().trim().required(),
    signatureTitle: yup.string().trim().required(),
    signatureDate: yup.string().trim().required(),

    //Submit
    submitted: yup.string().nullable().notRequired()
});

schema = schema.test( // this test is added additional to any other (build-in) tests
    'socioEconomicStatusTest',
    'message', // we'll return error message ourself if needed
    (obj) => {
        if (!obj.socioEconomicStatus || !obj.socioEconomicStatus.length) {
            return new yup.ValidationError(
                'Check at least one checkbox',
                null,
                'socioEconomicStatus'
            );
        }

        return true;
    }
);

schema = schema.test(
    'ownersTest',
    'message',
    (obj) => {
        if (obj.owners) {
            for (var i = 0; i < obj.owners.length; i++) {
                var name = obj.owners[i]['name'];
                var title = obj.owners[i]['title'];
                var ownership = obj.owners[i]['ownership'];

                if (!name || name.trim() === '') {
                    return new yup.ValidationError(
                        'Name is required',
                        null,
                        'owners[' + i + '].name'
                    );
                }

                if (!title || title.trim() === '') {
                    return new yup.ValidationError(
                        'Title is required',
                        null,
                        'owners[' + i + '].title'
                    );
                }

                if (!ownership || ownership.trim() === '') {
                    return new yup.ValidationError(
                        'Ownership is required',
                        null,
                        'owners[' + i + '].ownership'
                    );
                }
            }
        }

        return true;
    }
);

schema = schema.test(
    'securityClearancesTest',
    'message',
    (obj) => {

        if (obj.facilitySecurityClearance === 'True') {
            if (obj.securityClearances) {
                for (var i = 0; i < obj.securityClearances.length; i++) {
                    var dateOfApproval = obj.securityClearances[i]['dateOfApproval'];

                    var dateIsValid = moment(dateOfApproval, dateFormat, true).isValid();

                    if (!dateIsValid) {
                        return new yup.ValidationError(
                            'Enter valid Date of Approval',
                            null,
                            'securityClearances[' + i + '].dateOfApproval'
                        );
                    }
                }
            }
        }

        return true;
    }
);

schema = schema.test(
    'yearEstTest',
    'message',
    (obj) => {
        if ((obj.yearEst && obj.yearEst.length && obj.yearEst.length !== 4) || isNaN(obj.yearEst)) {
            return new yup.ValidationError(
                'Enter a valid year',
                null,
                'yearEst'
            );
        }

        return true;
    }
);

schema = schema.test(
    'yearsWithNameTest',
    'message',
    (obj) => {
        if (isNaN(obj.yearsWithName)) {
            return new yup.ValidationError(
                'Enter a valid number',
                null,
                'yearsWithName'
            );
        }

        return true;
    }
);

schema = schema.test(
    'dbNumberTest',
    'message',
    (obj) => {
        if (obj.dbNumber && obj.dbNumber.length && (obj.dbNumber.length !== 9 && obj.dbNumber.length > 0)) {
            return new yup.ValidationError(
                'Enter your 9 (nine) digit D&B number',
                null,
                'dbNumber'
            );
        }

        return true;
    }
);

schema = schema.test(
    'accountingSystemApprovalDateTest',
    'message',
    (obj) => {
        var isValid = moment(obj.accountingSystemApprovalDate, dateFormat, true).isValid();
        if (obj.accountingSystem === 'True' && !isValid) {
            return new yup.ValidationError(
                'Enter a valid date',
                null,
                'accountingSystemApprovalDate'
            );
        }

        return true;
    }
);

schema = schema.test(
    'signatureDateTest',
    'message',
    (obj) => {
        var isValid = moment(obj.signatureDate, dateFormat, true).isValid();
        if (!isValid) {
            return new yup.ValidationError(
                'Enter a valid date',
                null,
                'signatureDate'
            );
        }

        return true;
    }
);

export default schema;
